import { render, staticRenderFns } from "./tabFinanzas.vue?vue&type=template&id=669ef61b"
import script from "./tabFinanzas.vue?vue&type=script&lang=js"
export * from "./tabFinanzas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports